<template lang="pug">
  page
    section.about-section
      .container(v-if="sending")
        content-placeholders(:animated="true")
          .row
            .col-sm-6.mt-5(v-for="i in 6")
              content-placeholders-heading(:img="true")
      .container(v-else)
        .row.pt-5
          .col-sm-12
            router-link(:to="{name: 'demoday'}")
              i.feather-arrow-left
              | Back
          .col-sm-6.mt-3(v-for="(item,index) in eventdays" :data-tooltip="item.startup.brief" :data-tooltip-conf="(index<4)?'bottom multiline':index > (eventdays.length-4)?'top multiline':'bottom multiline'")
            .grid-item
              router-link.row(:to="{name:'stall', params: {id:item.id} }" )
                .col-sm-4
                  img(:src="$backend+'/storage/logos/'+item.startup.logo")
                .col-sm-8.p-3
                  h4 {{item.startup.name}}
                  span(v-for="product in item.startup.products") 
                    .badge.bg-azure.mr-1 {{product.sector}}
                    .badge.bg-teal.mr-1 {{product.subsector}}                    


</template>

<script>
// @ is an alias to /src
import page from '@/components/frontend/page'
import pagination from '@/components/pagination';
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DemoDay',
  props: ['id'],
  components: {
    page,
    pagination
  },
  data(){
    return {
      eventdays: []
    }
  },
  computed:{
    ...mapState('api', ['sending']),
  },
  methods:{
    load_data(){
      var vm = this;
      this.call({ _vm: this, endpoint:'stalls/'+this.id, method: 'POST' })
        .then((response)=>{
          vm.eventdays = response.data;
        });
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    this.load_data();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_mixins';


@keyframes glowing {
  0% {
    // background-color: #0091b2;
    box-shadow: 0 0 1px #020c9b66;
    transform: scale(1);
  }
  50% {
    // background-color: #21c7ed;
    box-shadow: 0 0 20px #303df766;
    transform: scale(.9);
  }
  100% {
    // background-color: #0091b2;
    box-shadow: 0 0 1px #020c9b66;
    transform: scale(1);
  }
}

.text-justify{
  text-align: justify;
}

.about-section{
  padding-top: 80px;
  padding-bottom: 80px;
  .grid-item{
    transition: all 0.14s ease-in-out;
    border-radius: 0.25rem;
    border: 1px solid #e7eaf3;
    // padding: 40px 20px;
    // text-align: center;
    // display: flex;
    justify-content: center;
    align-items:center;
    overflow: hidden;
    &:hover{
      // box-shadow: 0 0 18px rgba(0,0,0,0.06);
      // transform: translateY(-3px);
      transition: all 1s ease;
      animation: glowing 1300ms infinite;

      &:before{
        content: 'Click To visit Stall';
        background: #3fafef;
        padding: .5rem 1rem;
        color:white;
        position:absolute;
        right: 0;
        z-index: 1;
      }
    }
    img{
      max-height: 200px;
    }
    a{
      text-decoration: none;
    }
  }
}

</style>